module.exports = __webpack_public_path__ + "img/ez-slot-guitar-card.11daff9c.png";